module.exports = __webpack_public_path__ + "static/media/1023482.906fb05b.png";